import {
    FORM_OPT_IN_CHANNELS_KEY,
    FORM_OPT_IN_KEY,
    OPT_IN_CHANNELS,
} from '@constants';
import { OptInChannel } from '@types';

export const isOptInChannels = (
    value: unknown
): value is Array<OptInChannel> => {
    return (
        Array.isArray(value) && value.every((v) => OPT_IN_CHANNELS.includes(v))
    );
};

export const processOptIns = (data: Record<string, unknown>) => {
    const optIn =
        typeof data[FORM_OPT_IN_KEY] === 'boolean'
            ? data[FORM_OPT_IN_KEY]
            : false;

    delete data[FORM_OPT_IN_KEY];

    if (optIn && isOptInChannels(data[FORM_OPT_IN_CHANNELS_KEY])) {
        data.optIns = data[FORM_OPT_IN_CHANNELS_KEY].reduce(
            (acc, channel) => {
                acc[channel] = true;
                return acc;
            },
            {} as Record<OptInChannel, true>
        );
    }

    delete data[FORM_OPT_IN_CHANNELS_KEY];
};
